/** Auto-generated from landing-secondary-i18n-source-ja.md */
export const landingSecondaryJa = {
  help: {
    index: {
      seo: {
        title: 'ヘルプセンター | Veeso AI チュートリアル＆サポート',
        description:
          'Veeso AI のステップバイステップのチュートリアル、FAQ、サポートをご利用いただけます。コンテンツを実用レベルのデザインに素早く変える方法を学びましょう。',
        keywords:
          'Veeso AI ヘルプ、AI デザインサポート、コンテンツファーストデザイン、チュートリアル、FAQ、SNS デザイン、中小企業向けデザインツール',
      },
      hero: {
        title: 'ヘルプセンター',
        subtitle:
          'AI デザインの旅をサポートするチュートリアル、FAQ、サポート情報をご覧いただけます。',
      },
      category: {
        getting_started: {
          title: 'はじめに',
          description: 'Veeso AI の基本と、最初のデザインを作成する方法を学びましょう。',
        },
        account_billing: {
          title: 'アカウント＆お支払い',
          description: 'サブスクリプション、お支払い情報、アカウント設定を管理できます。',
        },
        features_tools: {
          title: '機能＆ツール',
          description:
            'オートレイアウトから AI コンテンツ生成まで、Veeso AI の機能を詳しくご紹介します。',
        },
        troubleshooting: {
          title: 'トラブルシューティング',
          description: 'よくある問題の解決方法と、サポートへの問い合わせ方法をご案内します。',
        },
      },
      contact: {
        heading: 'さらにサポートが必要ですか？',
        cta: 'サポートに問い合わせる',
      },
      faq: {
        title: 'よくある質問',
        items: [
          {
            question: 'Veeso AI とは何ですか？',
            answerParagraph1:
              'デザインリソースが限られ、納期に追われる中小企業のオーナー、マーケター、オペレーション担当者、創業者にとって、プロフェッショナルなビジュアルの制作は時間とコストがかかります。',
            answerParagraph2:
              'Veeso はコンテンツファーストのデザインツールで、コピーライティングをワンクリック・1 分で、デザインスキル不要で洗練されたビジュアルに変換します。',
            answerParagraph3:
              'コンテンツやテキストを貼り付けるだけで、SNS 投稿、ポスター、プレゼンテーション、カルーセル、複数ページのパンフレット、長文コンテンツ、レストランメニュー、招待状、ロールアップバナー、チラシ、アルバムカバーなど、美しいデザインを瞬時に生成できます。',
          },
          {
            question: 'Veeso は AI 画像生成ツールとどう違いますか？',
            answerParagraph1:
              'ほとんどの AI デザインツールは画像を生成しますが、Veeso は次の特徴を備えた、完全に編集可能なデザインファイルを生成します：',
            listItems: [
              '編集可能なテキストブロック',
              '論理的なコンテンツ階層',
              '複数ページのフォーマット',
              'エクスポート対応のデザイン',
            ],
          },
          {
            question: 'Veeso AI は誰のために作られていますか？',
            answer:
              'Veeso は、デザイナーを雇ったり、コンテンツのフォーマットに何時間も費やしたりすることなく、プロフェッショナルなデザインを必要とするクリエイター、ソロ創業者、マーケター、中小企業（SMB）向けに設計されています。',
          },
          {
            question: 'コンテンツファーストの哲学とは何ですか？',
            answerParagraph1:
              'コンテンツファーストとは、デザインがテンプレートや画像からではなく、あなたの情報から始まるという考え方です。固定テンプレートを探してコンテンツをそこに無理に当てはめるのではなく、Veeso は元のテキストを分析し、明確なセクション、見出し、視覚的な階層に自動的に構造化します。私たちは、あなたのコンテンツが次のものに縛られるべきではないと考えています：',
            listItems: [
              '特定のスライドレイアウト',
              '硬直したテンプレート',
              '単一のプラットフォームフォーマット',
            ],
            answerParagraph2:
              'Veeso はコンテンツとフォーマットを切り離し、同じ入力を次のような形に変換できるようにします：',
            listItems2: [
              'プレゼンテーション',
              'ニュースレター',
              'SNS 投稿',
              'レポート',
              'パンフレット',
            ],
            answerParagraph3: 'ひとつのコンテンツソースから、複数のデザインアウトプットへ。',
          },
          {
            question: 'Magic Template とは何ですか？',
            answerParagraph1:
              'Magic Template は Veeso AI のスタイル制御システムです。固定的・静的なテンプレートとは異なり、Magic Template は次の要素に基づいてレイアウト構造を動的に適応させます：',
            listItems: ['コンテンツの長さ', '情報の階層', 'トーンと意図', '出力フォーマット'],
            answerParagraph2:
              'セクション、見出し、ビジュアル、余白を賢く配置し、手動でフォーマットする必要なく、プロフェッショナルなデザインファイルを作成します。',
          },
          {
            question: 'Veeso でどのような種類のファイルを作成できますか？',
            answer:
              'プレゼンテーション、ニュースレター、SNS 投稿、レポート、ワンページャー、パンフレット、長文コンテンツページなど、さまざまなファイルを作成できます。すべてあなたが入力した元のテキストから生成されます。',
          },
          {
            question: '生成されたデザインは編集できますか？',
            answer:
              'はい。すべての出力は完全に編集可能です。エクスポート前に、Veeso 内でテキスト、レイアウト、画像、構造、ブランディング要素を直接調整できます。',
          },
          {
            question: 'Veeso は無料で使えますか？',
            answer:
              'はい。Veeso は毎日リフレッシュされるクレジットを含む無料プランを提供しており、初期費用なしで試して作成いただけます。より多くのクレジットや高度な機能をご希望の場合は、有料プランにアップグレードできます。',
          },
          {
            question: 'クレジットとは何ですか？',
            answerParagraph1:
              'クレジットは、新しいデザインの生成、AI とのチャットによるデザイン編集、背景の削除、その他の AI ツールなど、すべての AI 機能で使用されます。',
            answerParagraph2:
              '手動編集（テキストの移動、色の変更、要素のサイズ変更など）やデザインのエクスポートには、クレジットは一切使用されません。',
            answerParagraph3: 'デイリークレジットは毎日 UTC 0:00 にリフレッシュされます。',
          },
          {
            question: '作成したものを商用目的で使用できますか？',
            answerParagraph1: '無料プラン：個人および非商用利用のみ。',
            answerParagraph2:
              '有料プラン：生成された作品はフォントやメディア素材を含めて商用利用のライセンスが付与されます。',
          },
        ],
      },
      legal: {
        heading: '法的事項＆プライバシー',
        privacy: {
          title: 'プライバシーポリシー',
          description: 'お客様のデータの取り扱いについて',
        },
        terms: {
          title: '利用規約',
          description: '利用者同意事項とルール',
        },
        cookie: {
          title: 'Cookie ポリシー',
          description: 'Cookie の使用について',
        },
      },
    },
    getting_started: {
      seo: {
        title: 'Veeso AI をはじめる | チュートリアル＆ガイド',
        description:
          'Veeso AI のはじめ方をご紹介します。最初のデザイン作成、クレジットの仕組み、AI 機能の使い方をステップバイステップで解説します。',
        keywords:
          'Veeso AI はじめに、Veeso チュートリアル、Veeso の使い方、Veeso ガイド、Veeso でデザインを作成',
      },
      title: 'はじめに',
      description:
        'Veeso AI の基本と、最初のデザインを作成する方法を学びましょう。総合ガイドからはじめましょう。',
      content: [
        {
          title: 'Veeso AI とは？',
          body: 'Veeso AI はコンテンツファーストのデザインツールで、テキストやコンテンツを数秒で洗練されたプロフェッショナルなデザインに変換します。デザインスキルが必要な従来のデザインツールとは異なり、Veeso は AI を活用してコンテンツを視覚的に魅力的なレイアウトに自動構成します。テキストを貼り付けるだけで、SNS、プレゼンテーション、ニュースレターなどに対応した、完全に編集可能なデザインファイルが生成されます。',
        },
        {
          title: 'アカウントの作成',
          body: 'はじめるには veeso.ai にアクセスし、「Sign Up」をクリックして無料アカウントを作成してください。新規ユーザーにはウェルカムギフトとして 300 ボーナスクレジットが付与されます。お支払い情報は不要で、すぐに作成を開始できます。無料プランには毎日リフレッシュされるクレジットが含まれており、無料で Veeso の機能を試すことができます。',
        },
        {
          title: 'クレジットの仕組み',
          body: 'クレジットは、新しいデザインの生成、AI とのチャットによるデザイン編集、背景の削除、その他の AI ツールなど、Veeso のすべての AI 機能で使用されます。手動編集（テキストの移動、色の変更、要素のサイズ変更）やデザインのエクスポートにはクレジットを消費しません。デイリークレジットは毎日 UTC 0:00 にリフレッシュされます。友達を招待したり、プランをアップグレードしたり、特別なイベントに参加することで、さらにクレジットを獲得できます。',
        },
        {
          title: '最初のデザインを作成する',
          body: '最初のプロジェクトを作成するには、ワークスペースに移動して「Create」ボタンをクリックします。空のキャンバスからはじめることも、Magic Template から選ぶこともできます。入力欄にコンテンツやテキストを貼り付け、希望する出力フォーマット（SNS 投稿、プレゼンテーション、ニュースレターなど）を選択して「Generate」をクリックしてください。Veeso がコンテンツを分析し、数秒でプロフェッショナルなデザインを作成します。その後、デザインを編集・カスタマイズしてエクスポートできます。',
        },
        {
          title: 'Magic Template を使う',
          body: 'Magic Template は Veeso のインテリジェントなスタイル制御システムです。固定テンプレートとは異なり、Magic Template はコンテンツの長さ、情報の階層、トーン、出力フォーマットに基づいてレイアウト構造を動的に適応させます。つまり、同じコンテンツをさまざまなデザインフォーマットに自動変換でき、各用途に最適な視覚表現を実現します。',
        },
        {
          title: 'デザインを編集する',
          body: 'Veeso で生成されたすべてのデザインは完全に編集可能です。エディタ内でテキスト、レイアウト、画像、構造、ブランディング要素を直接調整できます。AI チャット機能で修正を依頼するか、直感的なインターフェースで要素を手動編集することもできます。手動編集はすべて無料で、クレジットを消費しません。',
        },
        {
          title: 'デザインをエクスポートする',
          body: 'デザインに満足したら「Export」ボタンをクリックします。無料プランのユーザーは透かし付きで標準フォーマット（PNG、JPG、WebP）にエクスポートできます。有料プランのユーザーは透かしなしの HD エクスポートに加え、PDF、PPT、HTML などの追加フォーマットを利用できます。エクスポートにクレジットは消費されません。',
        },
        {
          title: 'ベストプラクティス',
          body: '最良の結果を得るには、見出しやセクションで構造化された明確なコンテンツを提供してください。より多くの文脈を与えるほど、Veeso はあなたの意図を理解し、適切なデザインを作成できます。AI チャット機能を使ってデザインを繰り返し洗練させましょう。さまざまな Magic Template を試して、同じコンテンツがどのように多様なフォーマットで表現できるかを確認してください。',
        },
      ],
    },
    common: {
      back: 'ヘルプセンターに戻る',
      not_found: {
        title: 'カテゴリーが見つかりません',
        link: 'ヘルプセンターに戻る',
      },
      seo: {
        fallback_title: 'ヘルプセンター | Veeso AI',
        fallback_description: 'Veeso AI のヘルプセンタードキュメント',
      },
    },
    troubleshooting: {
      seo: {
        title: 'トラブルシューティング＆サポート | Veeso AI ヘルプ',
        description:
          'Veeso AI のサポートが必要ですか？メールでサポートチームにお問い合わせいただくか、Discord コミュニティにご参加ください。',
        keywords:
          'Veeso AI サポート、Veeso ヘルプ、Veeso お問い合わせ、Veeso トラブルシューティング',
      },
      title: 'トラブルシューティング',
      description: '発生した問題に対するヘルプとサポートをご利用いただけます。',
      discord: {
        title: 'Discord コミュニティ',
        description:
          'Discord コミュニティに参加して、リアルタイムのディスカッション、ユーザー同士のサポート、迅速な対応をご活用ください。',
        cta: 'Discord に参加する',
      },
      email: {
        title: 'メールサポート',
        description:
          '詳細な技術サポートやご質問は、help@veeso.ai までサポートチームにお問い合わせください。',
        cta: 'メールを送る',
      },
    },
  },
  solutions: {
    index: {
      seo: {
        title: 'Veeso ソリューション | コンテンツクリエイター＆中小企業向け AI デザインツール',
        description:
          'コンテンツクリエイター、創業者、中小企業向けの Veeso AI ソリューションをご紹介します。あなたのコンテンツからプレゼンテーション、ニュースレター、SNS ビジュアルを瞬時に生成できます。',
        keywords:
          'Veeso ソリューション、AI デザインツール、コンテンツファーストデザイン、クリエイター、中小企業チーム、プレゼンテーション生成、ニュースレターデザイン、SNS ビジュアル',
      },
      hero: {
        title: 'すべてのチームのためのソリューション',
        subtitle:
          'Veeso がチームの素晴らしいビジュアル制作をどのようにサポートできるかをご覧ください。マーケティングから人事まで、幅広くカバーします。',
      },
      card: {
        learn_more: '詳しく見る',
        marketers: {
          title: 'マーケター向け',
          description: '数分で魅力的なマーケティングコンテンツを作成。デザインスキルは不要です。',
        },
        hr: {
          title: '人事担当者向け',
          description:
            '魅力的な人事コンテンツ、採用資料、社内コミュニケーションをデザインできます。',
        },
        founders: {
          title: '創業者向け',
          description:
            'デザインチームなしでブランドを構築。スタートアップのためのプロフェッショナルなコンテンツを作成できます。',
        },
        creators: {
          title: 'クリエイター向け',
          description:
            '際立つコンテンツを作成。YouTube サムネイル、Instagram 投稿などに対応します。',
        },
        startups: {
          title: 'スタートアップ向け',
          description:
            'チームを拡大せずにデザインをスケール。スタートアップのスピードでプロフェッショナルな資料を作成できます。',
        },
      },
    },
  },
  aiToolsIndex: {
    seo: {
      title: 'マーケティング＆ビジネス向け 20 以上のおすすめ AI デザインツールライブラリ',
      description:
        '20 以上の AI デザインジェネレーターをひとつのプラットフォームで利用可能。編集可能なプレゼンテーション、Amazon A+ レイアウト、LinkedIn コンテンツ、ポスター、パンフレットなどを作成できます。',
      keywords:
        'AI デザインツール集、AI レイアウトジェネレーター、編集可能 AI デザイン、Instagram 投稿ジェネレーター、Amazon A+ コンテンツジェネレーター、LinkedIn 投稿ジェネレーター、YouTube サムネイルジェネレーター、AI パンフレットメーカー、AI ポスタージェネレーター、SNS デザインツール、ビジネスデザインツール、実用レベルの AI デザイン',
    },
    hero: {
      title: 'AI デザインツールライブラリ',
      subtitle: '画像だけでなく、編集可能なデザインファイルを作成',
    },
    category: {
      social_media: 'SNS',
      digital_marketing: 'デジタルマーケティング',
      business_print: 'ビジネス＆印刷物',
      stationery: 'ステーショナリー',
    },
    scroll: {
      left_aria: '左へスクロール',
      right_aria: '右へスクロール',
    },
    card: {
      fallback_title: 'AI デザインツール',
    },
  },
  learn: {
    shell: {
      brand_title: 'Veeso Learn',
      brand_subtitle:
        'プロンプト、編集、エクスポート、実践的なワークフローのためのプロダクトドキュメント。',
      mobile_menu_open: 'メニュー',
      mobile_menu_close: '閉じる',
    },
    nav: {
      section: {
        start: 'はじめに',
        create: '作成する',
        ship: '公開する',
        help: 'ヘルプ',
      },
    },
    chapter: {
      welcome: {
        title: 'ようこそ',
        heading: 'Veeso へようこそ',
        description:
          'Veeso のできること、コンテンツから編集可能なデザインへの変換、はじめの一歩を説明します。',
      },
      quickstart: {
        title: 'クイックスタート',
        heading: '初めての編集可能な AI デザインを素早く作る',
        description:
          'フォーマット選択、コンテンツと参考素材の追加、生成、テキスト・ビジュアルの編集、エクスポートまでの流れを解説します。',
      },
      prompt: {
        title: 'プロンプトガイド',
        heading: 'より良い入力で、より良いレイアウトを',
        description:
          'プロンプト、参考画像、ファイル、構造化された入力で Veeso の出力品質を高める方法を紹介します。',
      },
      editor: {
        title: 'エディタガイド',
        heading: 'Veeso エディタの仕組み',
        description:
          'AI チャット、ページパネル、テキスト編集、画像ツール、エクスポートまで、エディタ UI の使い方を説明します。',
      },
      export: {
        title: 'エクスポート',
        heading: '作品をエクスポートして配信する',
        description:
          'PNG、JPG、WebP、PDF、PPT、MP4、SVG、HTML への書き出しと、よくあるエクスポート問題の対処法をまとめます。',
      },
      credits: {
        title: 'クレジット',
        heading: 'クレジット、お支払い、プラン',
        description:
          '無料クレジット、有料クレジット、生成コスト、返金、請求の仕組みについて説明します。',
      },
      magic_play: {
        title: 'クリエイティブなアイデア',
        heading: 'クリエイティブなワークフローとユースケース',
        description:
          'アイデアやコンテンツを Veeso デザインに落とし込む、実践的なワークフローと活用例を紹介します。',
      },
      faq: {
        title: 'よくある質問',
        heading: 'よくある質問',
        description:
          'アカウント、クレジット、エクスポート、編集、サポートなど、よくある製品に関する質問への回答です。',
      },
      save_sync: {
        title: '保存と同期',
        heading: '保存と同期の仕組み',
        description:
          'プロジェクトの保存、変更の同期、バージョン履歴、データ復旧の仕組みを説明します。',
      },
      troubleshoot: {
        title: 'トラブルシューティング',
        heading: 'よくある問題を素早く解決',
        description:
          '空白キャンバス、生成の停止、レンダリング失敗、エクスポートエラー、編集トラブルなどの対処法をまとめます。',
      },
      shortcuts: {
        title: 'ショートカット',
        heading: 'キーボードショートカット',
        description: 'キーボードショートカットで編集・キャンバス操作を高速化する方法を紹介します。',
      },
    },
    search: {
      placeholder: 'ドキュメントを検索...',
      loading: '検索中...',
      no_results: '「{{query}}」の検索結果はありません',
      footer_hint: '↑↓ 移動 · ↵ 開く · Esc 閉じる',
    },
    markdown: {
      image_placeholder: '画像プレースホルダー',
      copy_example: 'サンプルをコピー',
      copying: 'コピー中...',
      copied: 'コピーしました',
    },
  },
  cookieBanner: {
    title: 'Cookie 設定',
    description:
      '当サイトでは、ご利用体験を向上させ、データを安全に保つために Cookie を使用しています。',
    privacy_link: 'プライバシーポリシー',
    manage_preferences: '設定を管理する',
    accept_all: 'すべて受け入れる',
    modal: {
      title: 'Cookie 設定',
      description: 'Cookie 設定を管理できます。以下で各種 Cookie の有効・無効を切り替えられます。',
      essential: {
        label: '必須 Cookie',
        description: 'ウェブサイトの機能に不可欠です。',
      },
      analytics: {
        label: '分析 Cookie',
        description: 'ウェブサイトの利用状況を把握するために役立ちます。',
      },
      marketing: {
        label: 'マーケティング Cookie',
        description: '関連性の高い広告を配信するために使用されます。',
      },
      save: '設定を保存',
    },
  },
  legal: {
    terms: {
      seo: {
        title: '利用規約 - Veeso AI',
        description:
          'Veeso AI プラットフォームの利用規約。利用者同意事項、利用規定、サービス条件についてご確認いただけます。',
        keywords: 'Veeso AI 利用規約、利用者同意事項、利用条件、Veeso AI 法的事項、サービス条項',
      },
      page: {
        title: '利用規約',
        last_updated: '最終更新日：2025 年 12 月 27 日',
      },
    },
    privacy: {
      seo: {
        title: 'プライバシーポリシー - Veeso AI',
        description: 'Veeso AI による個人情報の収集、利用、保護方法についてご確認いただけます。',
      },
      page: {
        title: 'プライバシーポリシー',
      },
    },
    cookie: {
      seo: {
        title: 'Cookie ポリシー - Veeso AI',
        description: 'Veeso AI による Cookie および類似技術の使用方法についてご確認いただけます。',
      },
      page: {
        title: 'Cookie ポリシー',
      },
      consent_button: 'Cookie 同意設定',
    },
  },
};
export const landingSecondaryPricingJa = {
  tryNow: '今すぐ購入',
  seoTitle: '料金とプラン | Veeso AI',
  seoDescription:
    '個人および小規模事業者向けの Veeso 料金プランをご紹介します。コンテンツから完成ファイルまで、プレゼンテーション、ニュースレター、SNS デザインをより速く作成できます。',
  seoKeywords:
    'Veeso AI 料金、料金プラン、デザインツール料金、コンテンツファーストデザイン、AI デザイン、デザイン効率化',
  page: {
    title: '料金',
    subtitle: '無料ではじめましょう。ビジネスの成長に合わせて容量を拡張できます。',
    billingPeriod: {
      monthly: '月払い',
      yearly: '年払い',
      saveUpTo: '最大 17% お得',
    },
    price: {
      free: '$0',
      perMonth: '月',
      perYear: '/ 年',
      savePerYear: '年間 ${{amount}} お得',
    },
    includes: '含まれるもの：',
    includesPro: 'Free のすべての機能に加えて：',
    includesUltra: 'Pro のすべての機能に加えて：',
    plans: {
      free: {
        name: 'Free',
        description: 'まずはお試し',
        cta: '無料で試す',
        features: {
          dailyCredits: '毎日 {{count}} リフレッシュクレジット',
          bonusCredits: '新規ユーザーに {{count}} ボーナスクレジット',
          monthlyCredits: '月間 {{count}} クレジット',
          fullFeaturedEditor: 'フル機能エディタ',
          standardExport: '標準エクスポート（Veeso バッジ付き）',
          uploadLimit: '1 回の生成につき最大 5 枚の素材画像をアップロード可能（ベータ）',
        },
      },
      pro: {
        name: 'Pro',
        description: 'プロのようにデザインする',
        cta: 'はじめる',
        monthlyCreditsSuffix: 'クレジット/月',
        dynamicMonthlyCredits: '月間 {{count}} クレジット',
        features: {
          removeBadge: 'Veeso バッジを削除',
          commercialLicense: '商用ライセンス',
          creditRollovers: '未使用クレジットを翌月に繰り越し',
          advancedExport: '高度なエクスポート',
          exportFormats: 'PPT / SVG / HTML',
          higherQuality: '高品質な AI 生成素材画像',
          uploadLimit: '1 回の生成につき最大 20 枚の素材画像をアップロード可能（ベータ）',
          multiPage: '複数ページ生成（最大 20 ページ）',
          earlyAccess: 'ベータ機能への早期アクセス',
          dedicatedSupport: '優先サポート',
        },
      },
      ultra: {
        name: 'Ultra',
        description: 'あなたのデザインを大規模に世界へ届ける',
        cta: 'はじめる',
        features: {
          everythingInPro: 'Pro のすべての機能に加えて：',
          brandKit: 'ブランドキット管理',
          apiAccess: 'API アクセス',
          unlimitedStorage: '無制限のクラウドストレージ',
          customContracts: 'カスタム契約・請求書発行',
          earlyAccess: 'ベータ機能への早期アクセス',
          prioritySupport: '専任サポート',
        },
      },
    },
    checkout: {
      invalidTier: '選択されたクレジットティアが無効です',
      invalidPlan: '選択されたプランが無効です',
      noUrl: 'チェックアウト URL が返されませんでした',
      failedToStart: 'チェックアウトを開始できませんでした',
    },
    faq: {
      title: 'よくある質問',
      subtitle: 'Veeso AI の料金と利用に関する回答',
      items: {
        whatIsVeesoAI: {
          question: 'Veeso AI とは何ですか？',
          answerParagraph1:
            'デザインリソースが限られ、納期に追われる中小企業のオーナー、マーケター、オペレーション担当者、創業者にとって、プロフェッショナルなビジュアルの制作は時間とコストがかかります。',
          answerParagraph2:
            'Veeso はコンテンツファーストのデザインツールで、コピーライティングをワンクリック・1 分で、デザインスキル不要で洗練されたビジュアルに変換します。',
          answerParagraph3:
            'コンテンツやテキストを貼り付けるだけで、以下のような美しいデザインを瞬時に生成できます：',
          products: [
            'SNS 投稿',
            'ポスター',
            'プレゼンテーション',
            'カルーセル',
            '複数ページのパンフレット',
            '長文コンテンツ',
            'レストランメニュー',
            '招待状',
            'ロールアップバナー',
            'チラシ',
            'アルバムカバー',
          ],
        },
        whatIsCredit: {
          question: 'クレジットとは何ですか？',
          answerParagraph1:
            'クレジットは、新しいデザインの生成、AI とのチャットによるデザイン編集、背景の削除、その他の AI ツールなど、すべての AI 機能で使用されます。',
          answerParagraph2:
            '手動編集（テキストの移動、色の変更、要素のサイズ変更など）やデザインのエクスポートには、クレジットは一切使用されません。',
          answerParagraph3: 'デイリークレジットは毎日 UTC 0:00 にリフレッシュされます。',
        },
        getMoreCredits: {
          question: 'クレジットを増やすにはどうすればいいですか？',
          answerParagraph1: 'クレジットを獲得する主な方法は 5 つあります：',
          answerParagraph2:
            '• 新規ユーザー：ウェルカムギフトとして 300 ボーナスクレジットを受け取る',
          answerParagraph3:
            '• 毎日のログイン：毎日 100 クレジットを獲得（UTC 0:00 にリフレッシュ）',
          answerParagraph4: '• 友達を招待：あなたと友達の両方が 200 クレジットを獲得',
          answerParagraph5: '• プランのアップグレード：有料プランに加入して月間クレジットを獲得',
          answerParagraph6:
            '• 特別イベント：プロモーションイベントに参加してボーナスクレジットを獲得',
        },
        creditExpiry: {
          question: 'クレジットには有効期限がありますか？',
          answerParagraph1: 'はい。クレジットの種類によって有効期限が異なります：',
          listItems: {
            dailyCredits: 'デイリークレジット：毎日 UTC 0:00 にリフレッシュ（繰り越し不可）',
            newUserBonus: '新規ユーザーボーナス：登録から 1 年間有効',
            referralCredits: '紹介クレジット：受け取りから 30 日間有効',
            promotionCredits: 'プロモーションクレジット：有効期限はイベントにより異なり、最長 1 年',
            monthlySubscription:
              '月額サブスクリプションクレジット：請求サイクル終了まで有効（繰り越し不可）',
            yearlySubscription:
              '年額サブスクリプションクレジット：請求サイクル終了まで有効（繰り越し不可）',
          },
        },
        creditConsumption: {
          question: 'クレジットはどのように消費されますか？',
          answerParagraph1: 'クレジットは以下の順序（優先度の高い順）で使用されます：',
          listItems: {
            dailyCredits: 'デイリークレジット',
            promotionCredits: 'プロモーションクレジット',
            referralCredits: '紹介クレジット',
            newUserBonus: '新規ユーザーボーナス',
            subscriptionCredits: 'サブスクリプションクレジット',
          },
        },
        inviteFriends: {
          question: '友達を招待してクレジット報酬を獲得するには？',
          answerParagraph1: '次のページへ：',
          link: {
            text: '友達を招待する',
          },
          answerParagraph2:
            '招待リンクを共有してください。あなたと友達の両方が 200 クレジットを受け取れます。',
        },
        designOwnership: {
          question: 'Veeso AI で作成したデザインの所有権は誰にありますか？',
          answer:
            'すべてのデザインソースファイルとプロジェクトは 100% お客様に帰属します。Veeso AI はデータプライバシーポリシーを厳格に遵守しており、お客様の許可なくコンテンツにアクセス・使用することはありません。',
        },
        commercialUse: {
          question: '作成したものを商用目的で使用できますか？',
          answerParagraph1: '無料プラン：個人および非商用利用のみ。',
          answerParagraph2:
            '有料プラン：生成された作品はフォントやメディア素材を含めて商用利用のライセンスが付与されます。',
        },
        studentDiscounts: {
          question: '学生・教育機関向けの割引はありますか？',
          answer: '現時点ではありませんが、将来的に提供される可能性があります。',
        },
        contactTeam: {
          question: 'Veeso チームに連絡するには？',
          answer: '次のページへ：',
          link: {
            text: 'お問い合わせ',
          },
          answerAfterLink: 'hi@veeso.ai へのご連絡も可能です。24 時間以内にご返信いたします。',
        },
        tieredPricing: {
          question: 'ティアード料金とは何ですか？',
          answer:
            '6000 クレジットのプランから 12000 クレジットのプランにアップグレードすると、システムは月間合計クレジットを 12000 に更新します。つまり、追加で 6000 クレジットが付与されるのであって、新たに 12000 クレジットが追加されるわけではありません。',
        },
        creditRollovers: {
          question: 'クレジットの繰り越しはどのように機能しますか？',
          answer:
            'クレジットは繰り越されません。未使用のクレジットは請求サイクル終了時に失効します。デイリークレジットは翌日に持ち越されません。',
        },
        upgradingDowngrading: {
          question: 'サブスクリプションをアップグレードまたはダウングレードするには？',
          answer:
            '料金・プランページからいつでもサブスクリプションプランをアップグレードまたはダウングレードできます。ダウングレードの場合、現在のプランは現行の請求サイクル終了まで有効です。ダウングレード後のプランは翌月から適用されます。アップグレードはすぐに反映され、月間合計クレジットは新プランの金額に更新されます。',
        },
        cancelSubscription: {
          question: 'サブスクリプションをキャンセルするには？',
          answer:
            '無料プランへのダウングレードを行い、所定の手順を完了してください。現在のプランは現行の請求サイクル終了まで有効です。',
        },
        getInvoice: {
          question: '請求書を取得するには？',
          answer:
            '「Manage」→「Invoices & Payments」へ進んでください。Stripe ポータルにリダイレクトされ、過去の請求書を確認できます。',
        },
        planReset: {
          question: 'プランとクレジット特典はいつリセットされますか？',
          answer:
            '月間クレジット枠は請求サイクルのリセットと同時にリセットされます。請求サイクルはサブスクリプション開始日と同じ日に毎月リセットされます。具体的な日時はお支払いセクションでご確認ください。',
        },
        dailyCreditsReset: {
          question: 'デイリークレジットはいつリセットされますか？',
          answer: 'デイリークレジットは毎日 UTC 0:00 にリセットされます。',
        },
      },
    },
  },
  popular: '人気のプラン',
};
export const landingSecondaryShellJa = {
  footer: {
    sr_only: 'フッター',
    col: {
      design_tools: 'デザインツール',
      resources: 'リソース',
      company: '会社情報',
      connect: 'フォロー',
    },
    link: {
      help: 'ヘルプセンター',
      solutions: 'ソリューション',
      tools: 'ツール',
      learn: '学ぶ',
      blog: 'ブログ',
      spotlight: 'スポットライト',
      changelog: '更新履歴',
      affiliates: 'アフィリエイト',
      about: '会社概要',
      contact: 'お問い合わせ',
      terms: '利用規約',
      privacy: 'プライバシー',
      cookie_policy: 'Cookie ポリシー',
      x: 'X',
      linkedin: 'LinkedIn',
      discord: 'Discord',
    },
    tooltip: {
      coming_soon: '近日公開',
    },
    copyright: '© {{year}} Veeso AI.',
  },
  nav: {
    logo_alt: 'Veeso AI',
    features: '機能',
    pricing: '料金',
    about: '会社概要',
    spotlight: 'スポットライト',
    start_free: '無料ではじめる',
    workspace: 'ワークスペース',
    toggle_menu_aria: 'メニューを切り替え',
    close_menu_aria: 'メニューを閉じる',
  },
};
